module.exports = " <div id=modal class=modal> <div class=modal__overlay></div> <div class=modal__inner> <div class=modal__content-wrapper> <%= content %> </div> <button aria-label=\"Close Modal\" class=btn-close--modal type=button> <svg class=btn-close__icon viewBox=\"0 0 100 100\"> <use xlink:href=#icon-close-wshadow></use> </svg> <span class=visually-hidden>Close</span> </button> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/tc/js/templates/modal.html
// module id = 483
// module chunks = 0 3 4 5 11